<template>
  <div>
    <div
      class="breadcrumb-area pos-relative w-100"
      v-if="dataPermission.includes('CNPS_DEVICE_ORDER_WARRANTY_VIEW')"
    >
      <h1>Chi tiết phiếu bảo hành</h1>
      <div class="btn-group float-right">
        <button
          v-if="
            checkStatusWaitProgress(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_UPDATE') ||
            checkStatusInProgress(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_UPDATE')
          "
          class="f12 font-medium btn btn-outline-secondary"
          @click="$router.push(`/warranty/active/${detail.id}`)"
        >
          Ghi nhận hoạt động bảo hành
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="showPolicyExchange('ASK', detail)"
        >
          Xin ý kiến BH tổng
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="showPolicyExchange('RELY', detail)"
        >
          BH tổng cho ý kiến
        </button>
        <button
          v-if="checkSendApprove(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_CREATE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="sendApproveItem(detail)"
        >
          Gửi duyệt
        </button>
        <button
          v-if="checkStatusAwaitReceive(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_RECEIVE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="sendReceiveItem(detail)"
        >
          Tiếp nhận
        </button>
        <button
          v-if="checkStatusAwaitApprove(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_APPROVE_REJECT')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="approveItem(detail)"
        >
          Duyệt
        </button>
        <button
          v-if="checkReject(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_APPROVE_REJECT')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="rejectItem(detail)"
        >
          Từ chối {{ detail.status === 'WAIT_RECEIVE' ? 'tiếp nhận' : '' }}
        </button>
        <button
          v-if="checkStatusPermission(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_UPDATE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="edit(detail.id)"
        >
          Sửa
        </button>
        <button
          v-if="checkCancel(detail.status, 'CNPS_DEVICE_ORDER_WARRANTY_CANCEL')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="cancelItem(detail)"
        >
          Hủy
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="form-detail col-sm-5 mr-100">
                  <h1>Thông tin phiếu bảo hành</h1>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Mã phiếu BH<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">{{ detail.code }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Kho tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">{{ detail.initInventoryName }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Người tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.creator ? detail.creator.name : '' }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ngày tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.createTime | formatDateTime7 }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Kho đang xử lý<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">{{ detail.processingInventoryName }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Thiết bị<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9" v-if="detail.deviceError">
                      <p class="form-control-plaintext f12">
                        {{ detail.deviceError.name }} - {{ detail.deviceError.serial }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Tình trạng bảo hành<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.type | transformData(Config.warrantyStatus) }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ghi chú<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">{{ detail.note }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Trạng thái<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        <span class="badge" :class="[detail.status ? detail.status : '']">
                          {{ detail.status | transformData(Config.statusWarranty) }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row" v-if="detail.status === 'APPROVED'">
                    <label for="" class="col-sm-3 col-form-label"
                      >Người duyệt<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.userApprove ? detail.userApprove.name : '' }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row" v-if="detail.status === 'APPROVED'">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ngày duyệt<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.approvedTime | formatDateTime7 }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-3 col-form-label"
                      >Người từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.userReject ? detail.userReject.name : '' }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-3 col-form-label"
                      >Ngày từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.rejectedTime | formatDateTime7 }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-3 col-form-label"
                      >Lý do từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">{{ detail.reasonReject }}</p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ảnh và file đính kèm<span class="float-right"></span
                    ></label>
                  </div>

                  <div class="form-group form-row">
                    <div class="ml-10">
                      <UploadMultiple
                        :lsData="detail.deviceError.imgErrors"
                        uniqueKey="images"
                        :canUpload="false"
                        titleClass="form-inner-heading"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-detail col-sm-5" v-if="detail.policyExchange">
                  <h1>Trao đổi chính sách bảo hành</h1>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Email merchant<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.policyExchange.emailMerchant }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Người xin ý kiến<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.policyExchange.consultor }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Đề xuất phương án<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{
                          detail.policyExchange.proposedMethod
                            | transformData(Config.treatmentMethodOption)
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ghi chú xin ý kiến<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.policyExchange.noteForComments }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Phương án xử lý<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{
                          detail.policyExchange.treatmentMethod
                            | transformData(Config.treatmentMethodOption)
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ghi chú BH tổng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail.policyExchange.generalWarrantyNotes }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Tình trạng trao đổi<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{
                          detail.policyExchange.exchangeStatus
                            | transformData(Config.exchangeStatusOption)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>Quá trình bảo hành</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">Thời gian</th>
                          <th scope="col" class="text-center">Người thực hiện</th>
                          <th scope="col" class="text-center">Kho</th>
                          <th scope="col" class="text-center">Lỗi</th>
                          <th scope="col" class="text-center">Đối tượng gây lỗi</th>
                          <th scope="col" class="text-center">Ghi chú</th>
                          <th scope="col" class="text-center">Tình trạng thiết bị</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="table-row" v-for="(item, index) in deviceHistory" :key="index">
                          <td class="text-center">
                            {{ item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                          </td>
                          <td class="text-center">
                            {{ item.creator.name }}
                          </td>
                          <td class="text-center">
                            {{ item.inventoryName }}
                          </td>
                          <td class="text-center">
                            {{ item.errors.join(', ') }}
                          </td>
                          <td class="text-center">
                            {{ item.reason | transformData(Config.faultMaker) }}
                          </td>
                          <td class="text-center">
                            {{ item.note }}
                          </td>
                          <td class="text-center">
                            {{ item.typeError | transformData(Config.stateDevices) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modaPolicyExchange
      v-if="showModalPolicyExchange"
      :closeModal="closeModal"
      :dataPolicyExchange="this.dataPolicyExchange"
      @updateInfoPolicyExchange="updateInfoPolicyExchange"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import modaPolicyExchange from './modaPolicyExchange.vue'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import UploadMultiple from '@/components/UploadMultiple.vue'

  export default {
    name: 'warranty-detail',
    data() {
      return {
        Config,
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        id: this.$route.params.id,
        detail: {},
        deviceHistory: [],
        showModalPolicyExchange: false,
        dataPolicyExchange: {},
      }
    },
    components: { modaPolicyExchange, UploadMultiple },
    mixins: [mxItemAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
    },

    methods: {
      backToList() {
        this.$router.push('/warranty')
      },
      async fetchData() {
        try {
          this.showLoading = true
          const data = await DeviceService.detailWarranty(this.id)
          if (data.success || data.code === 1000) {
            this.detail = data.data
            this.deviceHistory = data.data.historyList
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      showPolicyExchange(type, detail) {
        this.dataPolicyExchange = {
          type,
          id: detail.id,
        }
        this.showModalPolicyExchange = true
        this.$nextTick(s => this.$bvModal.show('modal-policy-exchange'))
      },
      closeModal() {
        this.$bvModal.hide('modal-policy-exchange')
        this.showModalPolicyExchange = false
      },
      updateInfoPolicyExchange() {
        this.fetchData()
        this.closeModal()
      },
    },
  }
</script>

<style scoped>
  .mr-100 {
    margin-right: 100px;
  }
  .ml-10 {
    margin-left: 10px;
  }
</style>
